import React, { useRef } from "react";
import '../../css/components/controls/HrnbFileUpload.css'

export default function HrnbFileUpload({
                                           label = "Загрузить файл",
                                           accept = "",
                                           onChange,
                                           value,
                                           error = "",
                                           hint = "",
                                           disabled = false,
                                           className = "",
                                           multiple = false,
                                           ...props
                                       }) {
    const inputRef = useRef();

    const handleClick = () => {
        if (!disabled) inputRef.current.click();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        if (disabled) return;
        const files = e.dataTransfer.files;
        if (files && files.length > 0 && onChange) {
            onChange({ target: { files } });
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    let fileNames = "";
    if (value && value.length) {
        fileNames = Array.from(value).map(f => f.name).join(", ");
    } else if (value && value.name) {
        fileNames = value.name;
    }

    return (
        <div className={`hrnb-fileupload-wrap ${className} ${disabled ? "hrnb-fileupload--disabled" : ""}`}>
            <label className="hrnb-fileupload-label">{label}</label>
            <div
                className={`hrnb-fileupload-dropzone${error ? " hrnb-fileupload--error" : ""}`}
                onClick={handleClick}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                tabIndex={disabled ? -1 : 0}
                style={{ cursor: disabled ? "not-allowed" : "pointer" }}
            >
                <input
                    ref={inputRef}
                    type="file"
                    accept={accept}
                    onChange={onChange}
                    disabled={disabled}
                    multiple={multiple}
                    className='hrnb-fileupload-input'
                    {...props}
                />
                <span className="hrnb-fileupload-text">
                    {fileNames || "Перетащите файл сюда или кликните для выбора"}
                </span>
            </div>
            {error
                ? <div className="hrnb-fileupload-error">{error}</div>
                : hint && <div className="hrnb-fileupload-hint">{hint}</div>
            }
        </div>
    );
}
